/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var RefreshOutlineIcon = function RefreshOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82609 12.6443C4.79423 8.91055 7.79522 5.85791 11.529 5.82606C13.5129 5.80913 15.3042 6.64748 16.5538 7.99999H14V9.99999H20V3.99999H18V6.61823C16.3846 4.88339 14.0716 3.80429 11.5119 3.82613C6.67363 3.86741 2.78488 7.82308 2.82616 12.6614C2.86744 17.4997 6.82311 21.3884 11.6614 21.3471C16.4997 21.3059 20.3885 17.3502 20.3472 12.5119L18.3472 12.529C18.3791 16.2627 15.3781 19.3154 11.6443 19.3472C7.91058 19.3791 4.85794 16.3781 4.82609 12.6443Z"
  }));
};
export default RefreshOutlineIcon;